import Vue from 'vue'
import { URL_SESSIONS } from '@/constants/urls.js'
import { SESSIONS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [SESSIONS_MANAGEMENT.STATE.ACTIVE]: null
}

const actions = {
  async [SESSIONS_MANAGEMENT.ACTIONS.GET_ACTIVE_SESSIONS] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getBusinessHost()}${URL_SESSIONS}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(SESSIONS_MANAGEMENT.MUTATIONS.GET_ACTIVE_SESSIONS, resp.data)
  },
  async [SESSIONS_MANAGEMENT.ACTIONS.CLEAR_ACTIVE_SESSIONS] ({ commit }) {
    commit(SESSIONS_MANAGEMENT.MUTATIONS.CLEAR_ACTIVE_SESSIONS)
  }
}

const mutations = {
  [SESSIONS_MANAGEMENT.MUTATIONS.GET_ACTIVE_SESSIONS] (state, lots) {
    state[SESSIONS_MANAGEMENT.STATE.ACTIVE] = lots
  },
  [SESSIONS_MANAGEMENT.MUTATIONS.CLEAR_ACTIVE_SESSIONS] (state) {
    state[SESSIONS_MANAGEMENT.STATE.ACTIVE] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
